exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio-player__wrapper[data-v-29ffbe42]{position:fixed;background:#f8f8f8;bottom:0;left:0;right:0;height:15%}.audio-player__wrapper .audio-player__chapter-name[data-v-29ffbe42]{color:#8e8ad3}", ""]);

// exports
